import React, { useEffect, useContext } from 'react';
import Anchor from 'ls-common-client/dist/components/Anchor';
import styled from 'styled-components';
import Container from 'ls-common-client/dist/components/Container';
import Animation from 'ls-common-client/dist/components/Animation';
import Text from 'ls-common-client/dist/components/Text';
import Panel from 'ls-common-client/dist/components/Panel';
import Image from 'ls-common-client/dist/components/Image';
import UserEmptyLayout from '../../components/UserManagement/UserEmptyLayout';
import listviewLoader from '../../animations/listviewLoader.json';
import { Context } from '../../context/AppContext';
import { MODALS } from '../../constants';
import { ReviewStars } from '../../components/Review';
import userSavedGraphic from '../../assets/userManagement/userSavedGraphic.svg';
import galleryPlaceholder from '../../assets/manage-listing/galleryPlaceholder.svg';
import { resize } from '../../services/imageResizer';
import SaveButton from '../../components/SaveButton';
import useFavourites from '../../hooks/useFavourites';
import config from '../../../src/client/config';

const StyledLink = styled(Anchor)`
  display: flex;
  flex: 1;
`;

const Saved = () => {
  const {
    user: { user: { id: userId } = {} } = {},
    modal: { showModal },
    media: { mobile, device },
    webp,
  } = useContext(Context);
  const { state, actions, loading } = useFavourites() || {};
  const hasFavourites = state && !!state.length;
  const { urlRoot } = config;

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      {(!userId || loading) && (
        <Container display="flex" justifyContent="center" alignItems="center">
          <Animation data={listviewLoader} width="300px" />
        </Container>
      )}
      {userId && !loading && !hasFavourites && (
        <UserEmptyLayout
          heading="You haven't saved any businesses yet."
          text="Save yourself time by saving your most-used businesses!"
          buttonText="Find a Business to Save"
          onClick={() => showModal(MODALS.SEARCH_AUTOSUGGEST)}
          graphic={userSavedGraphic}
          graphicFallback={userSavedGraphic}
        />
      )}
      {hasFavourites && (
        <Container
          padding={mobile ? '0 11px' : '0 30px'}
          marginTop={mobile ? '27px' : '58px'}
          marginBottom="40px"
        >
          <Text
            fontSize={mobile ? '22px' : '30px'}
            fontWeight="600"
            display="block"
            marginBottom="20px"
          >
            Your saved profiles
          </Text>
          <Container display="flex" flexWrap="wrap">
            {state.map(profile => {
              const {
                displayName,
                id,
                media,
                postcode,
                stateCode,
                suburb,
                vanityUrlPath,
                reviewAggregates,
              } = profile;
              const { averageRating } = reviewAggregates || {};
              const [image = {}] = media || [];

              return (
                <Container
                  display="flex"
                  key={id}
                  position="relative"
                  flex={
                    {
                      mobile: '0 0 100%',
                      tablet: '0 0 50%',
                      desktop: '0 0 25%',
                    }[device]
                  }
                >
                  <SaveButton
                    favourites={{ state, actions }}
                    profile={profile}
                    position="absolute"
                    right="30px"
                    top="30px"
                    delayRemove
                  />
                  <StyledLink href={`${urlRoot}/profile/${vanityUrlPath}`}>
                    <Panel padding="10px" flex="1">
                      <Container
                        width="100%"
                        height="140px"
                        marginBottom="20px"
                      >
                        <Image
                          width="100%"
                          height="100%"
                          objectFit="cover"
                          src={
                            resize(image.url || null, {
                              width: 600,
                              height: 300,
                              webp,
                            }) || galleryPlaceholder
                          }
                        />
                      </Container>
                      <Container>
                        <Text
                          fontSize="18px"
                          fontWeight="bold"
                          lineHeight="1.2"
                          display="block"
                          marginBottom="8px"
                          color="normal"
                          wordBreak="break-word"
                        >
                          {displayName}
                        </Text>
                        <Text
                          color="text300"
                          fontSize="14px"
                          display="block"
                          marginBottom="5px"
                          lineHeight="1.1"
                          wordBreak="break-word"
                        >
                          {suburb} {stateCode} {postcode}
                        </Text>
                        <ReviewStars
                          rating={averageRating}
                          average={
                            averageRating ? Number(averageRating.toFixed(1)) : 0
                          }
                          width={15}
                        />
                      </Container>
                    </Panel>
                  </StyledLink>
                </Container>
              );
            })}
          </Container>
        </Container>
      )}
    </>
  );
};

export default Saved;
